module.exports = __webpack_public_path__ + "img/verify.fd60b803.svg";